<template>
  <svg
    width="20"
    height="20"
    viewBox="0 0 20 20"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M13.0157 9.27363C14.2954 8.34031 15.1288 6.82984 15.1288 5.1282C15.1288 2.30051 12.8283 0 10.0006 0C7.17289 0 4.87238 2.30051 4.87238 5.1282C4.87238 6.82984 5.7057 8.34031 6.98547 9.27363C3.80422 10.491 1.53906 13.5754 1.53906 17.1795C1.53906 18.7347 2.80434 20 4.35957 20H15.6416C17.1968 20 18.4621 18.7347 18.4621 17.1795C18.4621 13.5754 16.197 10.491 13.0157 9.27363ZM6.41086 5.1282C6.41086 3.14883 8.02121 1.53848 10.0006 1.53848C11.98 1.53848 13.5903 3.14883 13.5903 5.1282C13.5903 7.10758 11.98 8.71797 10.0006 8.71797C8.02121 8.71797 6.41086 7.10758 6.41086 5.1282ZM15.6416 18.4615H4.35957C3.65266 18.4615 3.07754 17.8864 3.07754 17.1795C3.07754 13.362 6.18316 10.2564 10.0006 10.2564C13.8181 10.2564 16.9237 13.362 16.9237 17.1795C16.9237 17.8864 16.3486 18.4615 15.6416 18.4615Z"
      fill="#153D49"
    />
  </svg>
</template>
